<script>
    import Icon from './Icon.svelte';
    import { img_cdn, img_cdn_srcset } from './utils/image';

    /** @type {Course | Worksheet | Extra} */
    export let product;

    let className = '';
    export { className as class };
    export let style = '';
    export let mark_purchased = true;
</script>

<div
    class="relative w-24 flex-shrink-0 aspect-square bg-black drop-shadow-lg rounded-full overflow-hidden {className}"
    {style}
>
    <img
        src={img_cdn(product.icon, { w: 96, h: 96, fit: 'contain' })}
        srcset={img_cdn_srcset(product.icon, {
            w: 96,
            h: 96,
            fit: 'contain'
        })}
        alt={product.title}
        width="96"
        height="96"
        class="product-icon__image {product.purchased  && mark_purchased
            ? 'opacity-20'
            : ''}"
        loading="lazy"
    />

    {#if product.purchased && mark_purchased}
        <Icon
            icon="check"
            xl
            class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white"
        />
    {/if}
</div>

<style>
    .product-icon__image {
        position: absolute;
        inset: 0;
        display: block;
        width: 100%;
        height: 100%;
        min-width: 100%;
        min-height: 100%;
        max-width: none;
        object-fit: cover;
    }
</style>
